import React from 'react'
import estate from '../../assets/Core-icons/Industires-we-work-with/real-estate.svg'
import education from '../../assets/Core-icons/Industires-we-work-with/Education.svg'
import Ecommerce from '../../assets/Core-icons/Industires-we-work-with/ecommerces.png'
import  game from '../../assets/Core-icons/Industires-we-work-with/Games.png'
import fitness from '../../assets/Core-icons/Industires-we-work-with/Fitness.svg'
import health from '../../assets/Core-icons/Industires-we-work-with/Healthcares.svg'
import demand from '../../assets/Core-icons/Industires-we-work-with/On-demand.svg'
import grocery from '../../assets/Core-icons/Industires-we-work-with/groc.svg'

const CoreComponent2 = () => {
   const content = [
    {
      icon:estate,
      title: "Real Estate",
      class: "border-bottom",
      class2:'border-end'
    },
    {
      icon:education,
      title: "Education",
      class: "border-bottom",
       class2:'border-end'
    },
    {
      icon: Ecommerce,
      title: "Ecommerce",
      class: "border-bottom",
       class2:'border-end'
    },
    {
      icon: game,
      title: "Game",
      class: "border-bottom",
    },
    {
      icon: health,
      title: "Healthcare",
      class2:'border-end'
    },
    {
      icon:demand,
      title: "On-demand",
      class2:'border-end'
    },
    {
      icon: grocery,
      title: "Grocery",
      class2:'border-end'
    },
    {
      icon: fitness,
      title: "Fitness Center",
    },
  ];
  return (
     <div className="bg-light mt-80 mart marb mb-80 pt-60 padt padb pb-60">
        <div className="container text-center">
          <h2 className="mb-md-4 mb-2 h2-heading">Industries We Work With</h2>
          <p className='h1-para'>Latest and Greatest Services</p>
         <div className='d-flex mt-4 row justify-content-between'>
          {content.map((val,i)=>(
            <div className={`col-6 col-md-3  border-none-responsive mb-3 mb-md-0 text-center industry ${val.class} ${val.class2}  pt-4 pb-3 `} key={i} style={{width:""}}>
            <img src={val.icon} alt="" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
            <h4 className='mt-4 fw-semibold pb-3 h3-heading fs-5'>{val.title}</h4>
            </div>
        ))}
         </div>
         </div>
      </div>
         
    
  )
}

export default CoreComponent2